import tochtApi from "../../../api/e-loket/tochtApi";
import FilesHelper from "../../common/FilesHelper";

export default class GemeentePDFPageHelper {

	constructor(context, redirector) {
		this.context = context;
		this.redirector = redirector;
	}

	init() {
		const context = this.context;
		const params = context.props.match.params;
		const tochtId = params.tochtId;

		this.context.filesHelper = new FilesHelper(context, tochtId);

		this.getTocht(tochtId);

		context.setState({
			tochtId
		});
	}

	getTocht(tochtId) {
		const context = this.context;
		const ajaxActions = context.props.ajaxActions;

		ajaxActions.started();
		tochtApi.getTochtGemeente(tochtId)
			.then((response) => {
				ajaxActions.ended();
				this.processModel(response);
			})
			.catch((ex) => {
				ajaxActions.failed();
				context.props.throwException(ex);
			});
	}

	processModel(response) {
		const context = this.context;
		let model = response.data;

		context.setState({
			model
		});

		context.props.loadLayout(model.gemeenteNaam);
	}

	genereerPDF(pdfPollingProps) {
		const context = this.context;
		const ajaxActions = context.props.ajaxActions;
		const filesHelper = this.context.filesHelper;
		const tochtId = context.state.tochtId;

		ajaxActions.started();
		tochtApi.genereerGemeentePDF(tochtId).then((response) => {
			ajaxActions.ended();
			filesHelper.startPolling(pdfPollingProps);
		});
	}

	onTerug() {
		this.redirector.goTo("/e-loket/gemeente/veldtoertochten");
	}
}
